import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { DisplaySwitch, Flex } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import HistoricGraphs from './HistoricGraphs';

export default function HistoricTabs({ ilk }: { ilk: string }) {
  const [activeDisplayOption, setActiveDisplayOption] =
    useState('borrow_repay');
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const displayOptions = useMemo(
    () => [
      { key: 'borrow_repay', value: 'Borrow/Repay' },
      { key: 'deposit_withdraw', value: 'Deposit/Withdraw' }
    ],
    []
  );

  const [data, error] = useApi({
    url: `/groups/osero/ilks/${ilk}/historic-volume/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Flex flexDirection="column" gap="xs">
        <DisplaySwitch
          data={displayOptions}
          activeOption={activeDisplayOption}
          onChange={setActiveDisplayOption}
        />

        <HistoricGraphs
          data={data}
          type={activeDisplayOption}
          timeFilter={timeFilter}
          chartDaysAgo={chartDaysAgo}
        />
      </Flex>
    );
  }

  return <ChartSkeleton />;
}
